<template>
  <form>
    <md-card>
      <md-card-header>
        <h4 class="title">NG Word</h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>English NG Words List</label>
              <md-textarea v-model="en_words"></md-textarea>
            </md-field>
          </div>
          <div></div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>Japanese NG Words List</label>
              <md-textarea v-model="ja_words"></md-textarea>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100 text-right">
            <md-button class="md-raised md-success" @click="savelist"
              >Save</md-button
            >
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>

<script>
import ApiService from "@/services/ApiService";
export default {
  name: "ng-word",
  data() {
    return {
      selected: [],
      words: [],
      en_words: [],
      ja_words: []
    };
  },
  mounted() {
    this.fetchNGWords();
  },
  methods: {
    async fetchNGWords() {
      var responce = await ApiService.fetchNGWords();
      // console.log(responce.data);
      if (responce.data) {
        this.words = responce.data.words;
        this.en_words = responce.data.en_words;
        this.ja_words = responce.data.ja_words;
      }
    },

    async savelist() {
      // console.log("save list");
      var params = {
        // words: this.words,
        en_words: this.en_words,
        ja_words: this.ja_words
      };
      var res = await ApiService.saveNGWords(params);
      if (res.status === 200) {
        // console.log("Ng words saved");
        this.notifyVue("top", "center", "Ng Words saved", "success");
        this.fetchNGWords();
      } else {
        this.notifyVue(
          "top",
          "center",
          "Ng Words could not be saved",
          "warning"
        );
      }
    },

    notifyVue(verticalAlign, horizontalAlign, message, type) {
      var color = Math.floor(Math.random() * 4 + 1);
      this.$notify({
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    }
  }
};
</script>
